import React, { useState } from 'react';
import { NavLink, useNavigate, Navigate } from 'react-router-dom';
import { useAdminAuth } from '../AdminAuthContext';

const navItems = [
  { to: '/admin', label: 'Dashboard', icon: 'dashboard', end: true },
  { to: '/admin/leads', label: 'Leads', icon: 'people' },
  { to: '/admin/contatos', label: 'Contatos', icon: 'mail' },
  { to: '/admin/cms', label: 'CMS', icon: 'edit' },
  { to: '/admin/analytics', label: 'Analytics', icon: 'bar_chart' },
  { to: '/admin/seo', label: 'SEO', icon: 'manage_search' },
];

const AdminLayout = ({ children }) => {
  const { user, logout, isAuthenticated } = useAdminAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(true);

  if (!isAuthenticated) return <Navigate to="/admin/login" replace />;

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Sidebar */}
      <aside className={`${sidebarOpen ? 'w-56' : 'w-16'} bg-gray-900 text-white flex flex-col transition-all duration-200 flex-shrink-0 sticky top-0 h-screen`}>
        <div className="p-4 flex items-center gap-3 border-b border-gray-800">
          {sidebarOpen && (
            <img src="https://i.postimg.cc/1tVqPD4T/Prancheta-8-8.png" alt="Nexus" className="h-7 brightness-0 invert" />
          )}
          <button
            onClick={() => setSidebarOpen(o => !o)}
            className="ml-auto text-gray-400 hover:text-white"
          >
            <span className="material-icons text-xl">{sidebarOpen ? 'chevron_left' : 'chevron_right'}</span>
          </button>
        </div>

        <nav className="flex-1 py-4 space-y-1 px-2 overflow-y-auto">
          {navItems.map(({ to, label, icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                  isActive ? 'bg-blue-600 text-white' : 'text-gray-400 hover:bg-gray-800 hover:text-white'
                }`
              }
            >
              <span className="material-icons text-xl flex-shrink-0">{icon}</span>
              {sidebarOpen && label}
            </NavLink>
          ))}
        </nav>

        <div className="p-3 border-t border-gray-800">
          <button
            onClick={handleLogout}
            className="flex items-center gap-3 px-3 py-2 rounded-lg text-gray-400 hover:bg-gray-800 hover:text-white text-sm w-full transition-colors"
          >
            <span className="material-icons text-xl">logout</span>
            {sidebarOpen && 'Sair'}
          </button>
        </div>
      </aside>

      {/* Main */}
      <div className="flex-1 flex flex-col min-w-0">
        <header className="bg-white border-b border-gray-200 px-6 py-3 flex items-center justify-between">
          <h1 className="text-sm font-semibold text-gray-900">Nexus Admin</h1>
          <div className="flex items-center gap-4">
            <a
              href="/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 text-xs text-gray-500 hover:text-blue-600 transition-colors"
            >
              <span className="material-icons text-base">open_in_new</span>
              Ver site
            </a>
            <span className="text-xs text-gray-400">{user?.email}</span>
          </div>
        </header>
        <main className="flex-1 p-6 overflow-auto">
          {children}
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
